import { useState, useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { SideNav } from '../components/SideNav'
import { AppUserButton } from '../components/AppUserButton'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { ThemeProvider, createTheme, IconButton, Button } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import CastForEducationIcon from '@mui/icons-material/CastForEducation'
import { useQuery } from '@tanstack/react-query'
import { SettingsAPI } from '../api/SettingsAPI'
import { UserButton } from '@clerk/clerk-react'

export const MerchantDashboard = () => {
    const [mobileOpen, setMobileOpen] = useState(false)
    const [isClosing, setIsClosing] = useState(false)

    const { data } = useQuery({
        queryKey: ['user-profile'],
        queryFn: SettingsAPI.getUserProfile,
    })

    const handleDrawerClose = () => {
        setIsClosing(true)
        setMobileOpen(false)
    }

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false)
    }

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen)
    }

    const drawerWidth = 280

    const lightTheme = createTheme({
        palette: {
            mode: 'light',
            primary: {
                main: '#ffffff',
            },
        },
    })

    const TUTORIAL_URL =
        'https://www.youtube.com/watch?v=6hlyn298CtA&list=PLdGeNKN5wqOs9BKDtJAShfq0n0N-QtMct'

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <ThemeProvider theme={lightTheme}>
                <AppBar
                    position="fixed"
                    sx={{
                        width: { sm: `calc(100% - ${drawerWidth}px)` },
                        ml: { sm: `${drawerWidth}px` },
                    }}
                >
                    <Toolbar variant="dense">
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ mr: 2, display: { sm: 'none' } }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Button
                            variant="contained"
                            startIcon={<CastForEducationIcon />}
                            href={TUTORIAL_URL}
                            target="_blank"
                            color="info"
                            sx={{ textTransform: 'capitalize' }}
                        >
                            Tutorial
                        </Button>
                        <Box
                            sx={{
                                display: 'flex',
                                flex: 1,
                                height: '100%',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <UserButton
                                showName={true}
                                userProfileMode="navigation"
                                userProfileUrl="/merchant/settings"
                            />
                        </Box>
                    </Toolbar>
                </AppBar>
            </ThemeProvider>
            <SideNav
                mobileOpen={mobileOpen}
                handleDrawerClose={handleDrawerClose}
                handleDrawerTransitionEnd={handleDrawerTransitionEnd}
                userData={data?.data}
            />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    bgcolor: 'background.default',
                    marginTop: '3.1rem',
                    paddingX: '0.5rem',
                    paddingBottom: '0.5rem',
                }}
            >
                <Outlet />
            </Box>
        </Box>
    )
}
